// Avatar de persona (iniciales + color estable). Una sola regla para todas las
// pantallas: la misma persona se ve igual en la Lista Maestra, la Trazabilidad y
// Capacitaciones.

/** Índice de color estable (1..8) derivado de una identidad (id, subject o nombre). */
export function avatarColorIndex(seed: string): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) % 8;
  }
  return hash + 1;
}

/** Hasta 2 letras: iniciales de las dos primeras palabras, o las 2 primeras letras. */
export function nameInitials(name: string): string {
  const [first, second] = name.trim().split(/\s+/).filter(Boolean);
  if (first && second) {
    return (first.charAt(0) + second.charAt(0)).toUpperCase();
  }
  return (first ?? '?').slice(0, 2).toUpperCase();
}
